{
  "shellWaitLabel": "正在載入"
}
